'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var WEBSOCKETS_UPDATED = 'websockets:updated';
var NETWORK_STATUS_UPDATED = 'network-status:updated';
var RECONNECTING_UPDATED = 'reconnecting:updated';

exports.NETWORK_STATUS_UPDATED = NETWORK_STATUS_UPDATED;
exports.RECONNECTING_UPDATED = RECONNECTING_UPDATED;
exports.WEBSOCKETS_UPDATED = WEBSOCKETS_UPDATED;
